import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Success from './Success';
import Fail from './Failure';
import { HotKeys } from 'react-hotkeys';
import Header from './Header';
import Footer from './Footer';
import SecurityQuestion from './SecurityQuestion';
import { FadeTransform } from 'react-animation-components';
import './Modal.scss';

const keyMap = {
    close: 'escape'
};

export class Modal extends Component {
    constructor() {
        super();

        this.el = document.createElement('div');
        this.state = {
            portalRoot: document.getElementById('modal'),
            isShown: false
        };
    }

    keyHandlers() {
        return {
            close: () => this.close()
        };
    }

    lockScrolling() {
        document.body.style.overflow = 'hidden';
    }

    unlockScrolling() {
        document.body.style.overflow = 'auto';
    }

    componentDidUpdate() {
        if (this.props.isShown) {
            this.state.portalRoot.appendChild(this.el);
            this.lockScrolling();
        }
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevProps.isShown) {
            this.lockScrolling();
        } else {
            this.unlockScrolling();
        }

        this.state.portalRoot.appendChild(this.el);

        return null;
    }

    close() {
        this.unlockScrolling();
        this.state.portalRoot.removeChild(this.el);
    }

    custom() {
        return (
            <React.Fragment>
                <Header onCancelClick={() => this.close()}>{this.props.header}</Header>
                <div className="modal-body">{this.props.children}</div>
                <Footer onCancelClick={() => this.close()}>{this.props.footer}</Footer>
            </React.Fragment>
        );
    }

    default() {
        const definedModals = {
            success: <Success text={this.props.text} />,
            failure: <Fail text={this.props.text} />,
            security: (
                <SecurityQuestion {...this.props} onCancelClick={() => this.close()}>
                    {this.props.children}
                </SecurityQuestion>
            )
        };

        return definedModals[this.props.type];
    }

    render() {
        const isShown = this.props.isShown;

        if (!isShown) return null;

        return ReactDOM.createPortal(
            <HotKeys keyMap={keyMap} handlers={this.keyHandlers()}>
                <div className="modal-container">
                    <div className="overlay">
                        <FadeTransform
                            in
                            duration={200}
                            transformProps={{
                                exitTransform: 'translateY(-100px)'
                            }}>
                            <div className="box">
                                {this.props.type ? this.default() : this.custom()}
                            </div>
                        </FadeTransform>
                    </div>
                </div>
            </HotKeys>,
            this.el
        );
    }
}

Modal.propTypes = {
    type: PropTypes.oneOf(['success', 'failure', 'security']),
    canBeClosed: PropTypes.bool
};

Modal.defaultProps = {
    canBeClosed: true
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx